import React, { useState } from 'react'
import { useLocation } from 'hooks'
import { isPathActive, isPathActiveExact } from 'helpers'

import { Box, Flex, SVG, Link } from 'system'
import { Dot } from './Dot'
import { ReactComponent as IconRDArrowSVG } from '../assets/icon-arrow-right-down.svg'
import { ReactComponent as IconLUArrowSVG } from '../assets/icon-arrow-left-up.svg'

export const TreeNav = ({ children, ...props }) => (
  <Box as="ul" {...props}>
    {children}
  </Box>
)

const ChildTreeNav = ({ children, ...props }) => (
  <TreeNav overflow="hidden" myScale="t+" {...props}>
    {children}
  </TreeNav>
)

const BranchFigure = ({ ...props }) => (
  <Box
    flex="0 0 auto"
    height="12px"
    position="relative"
    width="12px"
    css={`
      transform: translateY(calc(-50% + 1px));
    `}
    {...props}
  >
    <Box
      bg="purple.90"
      height="100vh"
      left="0"
      position="absolute"
      bottom="0"
      width="1px"
    />
    <Box
      bg="purple.90"
      height="1px"
      left="0"
      position="absolute"
      bottom="0"
      width="100%"
    />
  </Box>
)

TreeNav.Item = ({ children, href, title }) => {
  const location = useLocation()
  const isActive = isPathActive(href, location)
  const isActiveExact = isPathActiveExact(href, location)

  return (
    <Box as="li" mb={1} boxStyle="lastNoMargin">
      <Link
        href={href}
        fontSize="small"
        color={isActive ? 'purple.50' : 'gray.20'}
        fontWeight={isActive ? 'bold' : 'normal'}
        position="relative"
        css={`
          transition: color ${p => p.theme.transition};

          &:hover,
          &:focus {
            color: ${p => p.theme.colors.purple[50]};
          }
        `}
      >
        {isActiveExact && (
          <Dot
            color="purple.50"
            size="7px"
            position="absolute"
            left={0}
            zIndex={1}
            top="50%"
            css={`
              transform: translate(calc(-100% - 0.75rem), -50%);
            `}
          />
        )}
        {title}
      </Link>
      {children && (
        <ChildTreeNav ml={1} pl={1}>
          {children}
        </ChildTreeNav>
      )}
    </Box>
  )
}

TreeNav.ChildItem = ({ children, href, title }) => {
  const location = useLocation()
  const isActive = isPathActive(href, location)
  const isActiveExact = isPathActiveExact(href, location)
  const [isExpanded, setIsExpanded] = useState(isActive)

  return (
    <Box as="li" mb={1} boxStyle="lastNoMargin">
      <Flex alignItems="center" position="relative">
        <BranchFigure mr={1} />
        {isActiveExact && (
          <Dot
            color="purple.50"
            size="7px"
            position="absolute"
            left={0}
            zIndex={1}
            css={`
              transform: translateX(calc(-50% + 0.5px));
            `}
          />
        )}
        <Flex
          as={Link}
          alignItems="center"
          href={href}
          color={isActiveExact ? 'purple.50' : 'slate.30'}
          fontWeight={isActiveExact ? 'bold' : 'normal'}
          fontSizeScale="s"
          css={`
            transition: color ${p => p.theme.transition};

            &:hover,
            &:focus {
              color: ${p => p.theme.colors.purple[50]};
            }
          `}
        >
          {title}
          {children && (
            <SVG
              x={1}
              y={1}
              svg={isExpanded ? IconLUArrowSVG : IconRDArrowSVG}
              fill="gray.60"
              width=".7rem"
              ml={1}
              position="relative"
              top="2px"
              onClick={e => {
                e.preventDefault()
                setIsExpanded(!isExpanded)
              }}
            />
          )}
        </Flex>
      </Flex>
      {(isActive || isExpanded) && children && (
        <ChildTreeNav ml="calc(12px + 1.5rem - 0.5rem)" pl={1}>
          {children}
        </ChildTreeNav>
      )}
    </Box>
  )
}
